import EXTERNAL_SEARCH_CONFIG from '@/app/config/search'
import TypesenseInstantSearchAdapter, {
  TypesenseInstantsearchAdapterOptions,
} from 'typesense-instantsearch-adapter'

export const getSearchClient = (
  apiKey: string,
  options?: Omit<TypesenseInstantsearchAdapterOptions, 'server'> & {
    server?: Partial<TypesenseInstantsearchAdapterOptions['server']>
  }
) => {
  const config = {
    ...options,
    server: {
      apiKey,
      sendApiKeyAsQueryParam: false,
      nodes: EXTERNAL_SEARCH_CONFIG.nodes,
      cacheSearchResultsForSeconds: 2 * 60, // Cache search results from server. Defaults to 2 minutes. Set to 0 to disable caching.
      ...(options?.server ?? {}),
    },
    additionalSearchParameters: {
      ...(options?.additionalSearchParameters ?? {}),
    },
  }

  return new TypesenseInstantSearchAdapter(config).searchClient
}
